import gql from 'graphql-tag'

export const GET_BANK_ACCOUNTS = gql`
  query ($page: Int, $perPage: Int) {
    bankAccounts(page: $page, perPage: $perPage) {
      nodes {
        id
        account
        accountBranch
        accountName
        bank
        stock {
          id
          name
          isMain
        }
      }
      pagesCount
      nodesCount
    }
  }
`

export default {
  GET_BANK_ACCOUNTS
}
